import AuthenticationService from 'services/authentication';

import ValidationError from 'domain/errors/ValidationError';

import validateSignUpForm from './validateSignUpForm';

const createAccount = async (signUpForm) => {
  if (!signUpForm) throw new Error('signUpForm cannot be empty');

  const errors = validateSignUpForm(signUpForm);
  if (errors) throw new ValidationError('Form is invalid');

  await AuthenticationService.createAccount(
    signUpForm.email,
    signUpForm.password,
    signUpForm.firstName,
    signUpForm.lastName
  );
};

export default createAccount;
